module.exports = __webpack_public_path__ + "38c771590f8e4b48ca82b43241741265.pdf";